import React from 'react';
import { MultipleAuthorTemplate } from '../multi-author';
import { getAuthorNameKeyword, getStoryPubKeyword } from '../utils';

import './photo-priority-multi-author.m.css';

export function PhotoPriorityMultiAuthorTemplate(props) {
  const photoPriorityPropsObj = Object.assign({}, props, {
    authorNameKeyword: getAuthorNameKeyword(),
    storyPubKeyword: getStoryPubKeyword(),
    hideImage: true
  });

  return <div styleName="photo-priority">
    <MultipleAuthorTemplate  {...photoPriorityPropsObj} />
  </div>;
}